import { useSnackbar } from "notistack"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import {
    AuthenticationAction,
    AuthenticationResponse,
    isRequiresActivationCodeResponse,
    isRequiresCompanySelectResponse,
} from "../../modules/login/loginTypes"
import {
    ACTIVATE_ACCOUNT_ACTIVATION_CODE_DA_ROUTE,
    ACTIVATE_ACCOUNT_ACTIVATION_CODE_ROUTE,
    ACTIVATE_ACCOUNT_SELECT_COMPANY_DA_ROUTE,
    ACTIVATE_ACCOUNT_SELECT_COMPANY_ROUTE,
    ACTIVATION_CODE_ROUTE,
} from "../../constants/routes"
import { useAppDispatch } from "../../modules/store/storeHooks"
import { setSelectCompanies } from "../../modules/login/loginSlice"
import { useAppLocalization } from "../../modules/localization/components/AppLocalizationProvider"

export function useLoginFlow(isDefault: boolean, isActivateDa: boolean) {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { l10n } = useAppLocalization()
    const { enqueueSnackbar } = useSnackbar()

    const handleAuthResponse = useCallback(
        (response: AuthenticationResponse) => {
            switch (response.authenticationResult.action) {
                case AuthenticationAction.REQUIRES_SELECT_COMPANY:
                    {
                        if (isRequiresCompanySelectResponse(response)) {
                            dispatch(setSelectCompanies(response))

                            navigate(
                                isActivateDa
                                    ? ACTIVATE_ACCOUNT_SELECT_COMPANY_DA_ROUTE
                                    : ACTIVATE_ACCOUNT_SELECT_COMPANY_ROUTE,
                            )
                        } else {
                            enqueueSnackbar({
                                variant: "error",
                                message: l10n.getString("auth-flow-authentication-result-server-error", {
                                    action: response.authenticationResult.action,
                                }),
                            })
                        }
                    }
                    break
                case AuthenticationAction.REQUIRES_ACTIVATION_CODE:
                    {
                        if (isRequiresActivationCodeResponse(response)) {
                            isDefault
                                ? navigate(ACTIVATION_CODE_ROUTE)
                                : navigate(
                                      isActivateDa
                                          ? ACTIVATE_ACCOUNT_ACTIVATION_CODE_DA_ROUTE
                                          : ACTIVATE_ACCOUNT_ACTIVATION_CODE_ROUTE,
                                      {
                                          state: { message: response.authenticationResult.message },
                                      },
                                  )
                        } else {
                            enqueueSnackbar({
                                variant: "error",
                                message: l10n.getString("auth-flow-authentication-result-server-error", {
                                    action: response.authenticationResult.action,
                                }),
                            })
                        }
                    }
                    break

                default: {
                    enqueueSnackbar({
                        variant: "error",
                        message: l10n.getString("auth-flow-authentication-unexpected-server-error", {
                            action: response.authenticationResult.action,
                        }),
                    })
                }
            }
        },
        [navigate, enqueueSnackbar],
    )

    return {
        handleAuthResponse,
    }
}
